<template>
  <el-table-column
    prop="vat.value"
    sortable="custom"
    label="Áfa"
    show-overflow-tooltip
    min-width="70px"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.vat">{{ scope.row.vat.value }}%</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'vat.value',
  };
</script>
